export default __webpack_public_path__ + "static/media/l_5.6cf864fc.jpg";